import React, { useState, useEffect } from 'react'

const DoYouWish = ({ handleAnswer, goNextStep, nextStep, emptyData, alreadyFilled, editMode, displayContextCM, createSequence, displayQuestion }) => {

    const [isSelected, setIsSelected] = useState()


    const handleYes = () => {
        setIsSelected('yes')
        handleAnswer(true)
        goNextStep(nextStep)
        if (!editMode && createSequence) {
            createSequence()
        }
    }

    const handleNo = () => {
        setIsSelected('no')
        handleAnswer(false)
        goNextStep(nextStep)
        if (displayContextCM) {
            displayContextCM()
        }
        if (emptyData) {
            emptyData()
        }
    }

    useEffect(() => {
        if (editMode) {
            if (alreadyFilled) {
                setIsSelected('yes')
                handleAnswer(true)
                goNextStep(5)
                if (displayQuestion) {
                    displayQuestion(false)
                }
            } else {
                setIsSelected('no')
                handleAnswer(false)
                goNextStep(5)
            }
        }
        // eslint-disable-next-line
    }, [alreadyFilled])


    return (
        <div className='text-center doYouWish'>
            <button
                className={(isSelected === 'no') ? 'wish wishButton' : 'noWish wishButton'}
                onClick={handleNo}>
                No
            </button>
            <button
                className={(isSelected === 'yes') ? 'wish wishButton' : 'noWish wishButton'}
                onClick={handleYes}>
                Yes
            </button>
        </div>
    )
}

export default DoYouWish
